import {
  ControlBlock_UpdateArticleModel,
  ControlBlock_UpdateClockSystemSerialNumberModel,
  ControlBlock_UpdateModelModel,
  ControlBlock_UpdateSerialNumberModel,
  ControlBlocksService,
  StandardTimeModel,
  StandardTimeOffsetModel,
} from "../api";
import {
  mapControlBlockTimeResponse,
  mapTimeValue,
} from "../shared/Helpers.utils";

export const BksApi = {

  // Обновление модели
  updateModel: async (id: string, model: string): Promise<boolean> => {
    const payload: ControlBlock_UpdateModelModel = {model};
    await ControlBlocksService.putApiControlBlocksModel(id, payload);
    return true;
  },

  // Обновление артикула
  updateArticle: async (id: string, article: string): Promise<boolean> => {
    const payload: ControlBlock_UpdateArticleModel = {article};
    await ControlBlocksService.putApiControlBlocksArticle(id, payload);
    return true;
  },

  // Обновление серийного номера
  updateSerialNumber: async (id: string, serialNumber: string): Promise<boolean> => {
    const payload: ControlBlock_UpdateSerialNumberModel = {serialNumber};
    await ControlBlocksService.putApiControlBlocksSerialNumber(id, payload);
    return true;
  },

  // Обновление серийного номера системы часов
  updateSystemSerialNumber: async (id: string, clockSystemSerialNumber: string): Promise<boolean> => {
    const payload: ControlBlock_UpdateClockSystemSerialNumberModel = {
      clockSystemSerialNumber: Number(clockSystemSerialNumber),
    };
    await ControlBlocksService.putApiControlBlocksClockSystemSerialNumber(id, payload);
    return true;
  },

  // Получение времени
  getTime: async (id: string) => {
    const response = await ControlBlocksService.getApiControlBlocksTime(id);
    return mapControlBlockTimeResponse(response as Record<string, unknown>);
  },

  // Обновление времени
  updateTime: async (id: string, time: string | Date): Promise<boolean> => {
    const payload: StandardTimeModel = {
      time: mapTimeValue(time),
    };

    await ControlBlocksService.postApiControlBlocksTimeUtc(id, payload);
    return true;
  },

  // Обновление часового пояса
  updateTimezone: async (id: string, offset: string): Promise<boolean> => {
    const payload = {
      offset,
    } as unknown as StandardTimeOffsetModel;

    await ControlBlocksService.postApiControlBlocksTimeTimezone(id, payload);
    return true;
  },
};
